const ActionTypes = {
  RECEIVE_POKEMONS: 'RECEIVE_POKEMONS',
  RECEIVE_POKEMONS_DETAIL: 'RECEIVE_POKEMONS_DETAIL',
  CLEAR_POKEMON_DETAIL: 'CLEAR_POKEMON_DETAIL',
  ADD_FAVORITE_POKEMON: 'ADD_FAVORITE_POKEMON',
  DELETE_FAVORITE_POKEMON: 'DELETE_FAVORITE_POKEMON',
  RECEIVE_POKEMONS_MORE: 'RECEIVE_POKEMONS_MORE',
  SET_FILTERED_BY_TYPE: 'SET_FILTERED_BY_TYPE',
};

export { ActionTypes };
